import { FullJoin } from './../../../apiclient/model/fullJoin';
import { Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';

import { LocalDataSource } from 'ng2-smart-table';
import { CustomEntityService } from '../../../apiclient/api/customEntity.service'
import { CustomEntityUtils } from '../../../custom-entity-utils.service';
import { UserSessionService } from '../../../UserSession/user-session.service';
import { TypePropertyFieldListElementComponent } from '../typepropertyfieldListElement.components';
import Map from 'ol/Map';
import Attribution from 'ol/control/Attribution';
import VectorSource from 'ol/source/Vector';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import OSM from 'ol/source/OSM';
import {Style,Fill, Stroke,Circle} from 'ol/style';
import {Point,Polygon,MultiPoint} from 'ol/geom';
import View from 'ol/View';
import {Draw, Modify, Snap} from 'ol/interaction';
import * as olEventsCondition from 'ol/events/condition';
import LayerSwitcher from 'ol-layerswitcher';
import Feature from 'ol/Feature';
import { NbDialogRef } from '@nebular/theme';
/**
 * Componente que renderiza el editor de relaciones
 */
@Component({
  selector: 'ngx-relaciones-editor',
  templateUrl: './relaciones-editor.component.html',
  styleUrls: ['./relaciones-editor.component.scss']
})
export class RelacionesEditorComponent implements OnInit {

  entities:any;
  elementId:any;
  customElement: any = {};
  customEntity: any = {};
  geospatial = false;
  sourceJoins: LocalDataSource = new LocalDataSource();
elementjoins: any;
  settingsjoins = {
    noDataMessage: 'No hay relaciones',
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
  },

    add: {
      addButtonContent: '<i class="nb-plus"></i><span class="btn-add-text">Nueva</span>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    edit: {
      editButtonContent: '<i class="far fa-edit small-btn"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline small-btn"></i>',

    },
    columns: {
      entityName: {
        title: 'Entidad Relacionada',
        type: 'text',
        editable: false,
      },
      id: {
        title:'Elemento Relacionado',
        valuePrepareFunction: (cell,row) => {
          return row.name;
        },
        type: 'text',
        editor: {
          type: 'custom',
          component: TypePropertyFieldListElementComponent,
        }
      },
    },
    rowClassFunction: (row) => {

      if( (row.data.byAttribute != undefined && row.data.byAttribute != null) || row.data.history != undefined ){
        return "joinByAttribute"
      }
    }
  };
  //configuracion mapa
  mapavisible :boolean = false;
  @ViewChild("maparelaciones") mapadiv: ElementRef;
  map: Map;
  parcelasSource: VectorSource;
  config: any = {
    target: 'visormap',
    center : [0,0]
  };
  relatedStyle =  new Style({
    stroke: new Stroke({
      color: 'red',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.3)',
    }),
  });

  elementStyle =  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.2)',
    }),
  });

  verticesStyle = new Style({
    image: new Circle({
      radius: 8,
      fill: new Fill({
        color: 'orange',
      })
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      var coordinates = feature.getGeometry().getCoordinates()[0];
      return new MultiPoint(coordinates);
    },
  });
relacionesTitle: string;

  constructor(private userSessionService : UserSessionService,
    private customEntityService: CustomEntityService,
    private router: Router,
    private customEntityUtils: CustomEntityUtils,
    protected dialogRef: NbDialogRef<any>) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
    this.initComponent()
  }

  /**
   * Inicializa el componente
   */
  async initComponent(){
    if(this.elementjoins != undefined){
      this.relacionesTitle = 'Relaciones vigentes del histórico';
      this.settingsjoins.actions.add = false;
      this.sourceJoins.load(this.elementjoins.map(j => {
          j.entityName = j.entity_name;
        return j;
      }))
    }else{
      this.relacionesTitle = 'Relaciones no espaciales';
      this.settingsjoins.actions.add = true;

    this.elementjoins = await this.customEntityUtils.getElementJoins(this.elementId)

    this.sourceJoins.load(this.elementjoins.simple)
    if(this.elementjoins.geospatial != null && this.elementjoins.geospatial.length > 0){
      this.geospatial = true;
      setTimeout(async ()=> {

        this.initMap();
        await this.pintarParcela(JSON.parse(JSON.stringify((await this.customEntityUtils.getElement(this.elementId)).geometry)),this.elementStyle)
        await this.pintarGeometrias(this.elementjoins.geospatial)
        this.map.getView().fit(this.parcelasSource.getExtent(),{padding:[100,100,100,100],nearest:true});

      },600);
    }

    this.customEntity = await this.customEntityUtils.getCurrentEntity();
    this.customElement = await this.customEntity.elements.filter(element => element.id == this.elementId)[0];
    }
  }

  /**
   * Carga los datos
   * @param elementId Id del elemento
   * @param entities Entidades
   */
  public loadData(elementId,entities){
    this.entities = entities;
    this.elementId = elementId;
  }

  /**
   * Pinta las geometrias relacionadas
   * @param geojoins
   */
  pintarGeometrias(geojoins: FullJoin[]){
    if (geojoins != null && geojoins.length > 0){
      for(const geojoin of geojoins){

        console.log(geojoin.geometry)
        this.pintarParcela(geojoin.geometry,this.relatedStyle)

      }
    }
  }


  /**
   * Pinta la geometría en el mapa
   * @param field
   * @param style
   */
  pintarParcela(field: any,style: any): void{




      if( field.type == 'Polygon'){
        console.log("Polygon")
        field.coordinates[0] = field.coordinates[0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })
      }else if(field.type == 'MultiPolygon'){
        field.coordinates[0] = field.coordinates[0][0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })
      }

      console.log(field)
      let feature = new Feature({
        geometry: new Polygon(
          field.coordinates),

        parcela: {name:field.name,region:field.region},
      });

      feature.setStyle(style);

      this.parcelasSource.addFeature(feature);





  }

  /**
   * Actualiza las relaciones
   */
  updateJoins():void{

    let listaJoins = []

    this.sourceJoins.getElements().then(async (elementos) =>{

      elementos.forEach(elemento => {
        listaJoins.push(Number(elemento.id))
      });

      await this.customEntityService.updatecustomelementjoins(this.elementId, this.customEntity.company_id,listaJoins,this.userSessionService.accessToken).toPromise();
      this.dialogRef.close();
      this.userSessionService.invalidateCachedCustomEntities()

    })
  }

  /**
   * Cierra el componente
   */
  cerrar():void{
    this.dialogRef.close();
  }

  /**
   * Inicializa el mapa
   */
  initMap() {
    this.mapadiv.nativeElement.innerHTML = "";
    console.log("INIT MAP")

    this.parcelasSource = new VectorSource();
    const attribution = new Attribution({
      html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
    });

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer({
          source: new OSM(),
          visible:false,
          title: 'Mapa Base',
          type:'base',
        }) ,
        new TileLayer({
          visible:false,
          title: 'Mapa PNOA',
          type:'base',
          source: new WMTS({
            attributions: ['<a href="httpS://www.ign.es" target="_blank">IGN</a>'],
            url: 'http://www.ign.es/wmts/pnoa-ma',
            layer: 'OI.OrthoimageCoverage',
            // matrixSet: 'EPSG:4326',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: olProj.get('EPSG:3857'),
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds
            }),
            style: [this.elementStyle]
          })
        }),
        new TileLayer({
          visible: true,
          title: 'Mapa Geográfico',
          type:'base',
          source: new WMTS({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
              'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
            layer: '0',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds,
            }),
            style: 'default',
            wrapX: true,
          }),
        }),
        new VectorLayer({
          source: this.parcelasSource,
        }),

      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });




      var layerSwitcher = new LayerSwitcher();
      this.map.addControl(layerSwitcher);

  }
}
